import { SETS_COMPACT_RESPONSE_VERSION } from "utils/api-route.constants";

export const QUERIES = {
  COLLECTION_USER: "collectionUser",
  COLLECTION_CARDS: "collectionCards",
  COLLECTION_FACETS: "collectionFacets",

  COLLECTION_IMPORTS_PAGED: "collectionImportsPaged",
  COLLECTION_IMPORT_DETAILS: "collectionImportsDetails",
  IMPORT_DRAFT_ROWS: "importDraftRows",
  IMPORT_DRAFT_STATUS: "importDraftStatus",

  DECK_USER: "deckUser",
  DECK_DETAILS: "deckDetails",
  DECK_ENGAGEMENT: "deckEngagement",
  DECKS_PUBLIC: "decksPublic",
  CARD_OWNERSHIP_STATUS: "cardOwnershipStatus",
  DECK_COMMENTS: "deckComments",

  TRADE_LISTS_PAGED: "tradeListPaged",
  TRADE_LISTS_USER: "tradeListsUser",
  TRADE_LISTS_DETAILS: "tradeListDetails",
  TRADE_LIST_ITEMS: "tradeListItems",
  TRADE_LIST_IMPORT_DETAILS: "tradeListImportDetails",
  TRADE_LIST_IMPORTS_PAGED: "tradeListImportsPaged",
  TRADE_LIST_FACETS: "tradeListFacets",
  TRADE_ITEM_AVAILABILITY: "tradeItemAvailability",
  USER_RECENT_TRADES: "userRecentTrades",
  MATCHED_TRADES: "matchedTrades",
  TRADE_PROPOSAL: "tradeProposal",
  TRADE_PROPOSAL_BY_CHAT: "tradeProposalByChat",
  TRADE_PROPOSAL_LOCATION_OPTIONS: "tradeProposalLocationOptions",
  SATISFYING_ITEMS: "satisfyingItems",

  CARD_FACETS: "cardFacets",
  MAGIC_CARDS_AUTOCOMPLETE: "magicCardsAutocomplete",
  MAGIC_CARDS_CHART: "magicCardsChart",
  MAGIC_CARDS_DETAILS: "magicCardsDetails",
  MAGIC_CARDS_PAGED: "magicCardsPaged",
  MAGIC_CARDS_PRINTINGS: "magicCardsPrintings",
  CARD_AVAILABILITY: "cardAvailability",
  CARD_CITIES: "cardCities",
  REVERSE_GEOCODE: "reverseGeocode",
  ONBOARDING_CITIES: "onboardingCities",
  ONBOARDING_COLLECTION_COUNT: "onboardingCollectionCount",
  CHATS: "chats",
  CHAT_DETAILS: "chatDetails",
  MESSAGES: "messages",
  LAST_MESSAGE: "lastMessage",
  NOTIFICATIONS: "notifications",
  NOTIFICATION_PREFERENCES: "notificationPreferences",
  USER_PREFERENCES: "userPreferences",
  USER_ACTIVITY_STATUS: "userActivityStatus",
  USER_PREVIEW: "userPreview",
  SETS: "sets",
  SETS_COLLECTION: "setsCollection",
  SETS_PAGED: "setsPaged",
  SET: "set",
  SEALED_PRODUCTS: "sealedProducts",

  LGS_ALL: "lgsALL",
  LGS_USER: "lgsUser",
  LGS_USERS: "lgsUsers",
  LGS_CARDS: "lgsCards",
  LGS_MATCHED_CARDS: "lgsMatchedCards",
  LGS_CARD_FACETS: "lgsCardFacets",

  CITY_CARDS: "cityCards",
  CITY_MATCHED_CARDS: "cityMatchedCards",
  CITY_STATS: "cityStats",
  CITY_CARDS_PREVIEW: "city_cards_preview",
  CITY_CARD_FACETS: "cityCardFacets",

  USER_CARD_FACETS: "userCardFacets",

  APP_VERSION: "appVersion",
  APP_USER: "appUser",

  METAGAME_AVAILABLE_FORMATS: "metagameAvailableFormats",
  WAITLIST_COUNT: "waitlistCount",

  METRO_ROUTES: "metroRoutes",

  GEO_DETECT: "geoDetect",

  REFERRAL_CODE: "referralCode",
  REFERRAL_STATS: "referralStats",
  REFERRED_USERS: "referredUsers",

  BILLING_OFFERINGS: "billingOfferings",
  BILLING_ME: "billingMe",

  WALLET_CREDIT: "walletCredit",

  BUYLIST_SUBMISSIONS: "buylistSubmissions",

  DROPS_PUBLIC: "dropsPublic",
  DROPS_LIST: "dropsList",
  DROPS_ME: "dropsMe",
  DROPS_OFFERING: "dropsOffering",
};

export const SETS_COMPACT_QUERY_KEY = [
  QUERIES.SETS,
  SETS_COMPACT_RESPONSE_VERSION,
] as const;
